import { render, staticRenderFns } from "./IdamSegmentator.vue?vue&type=template&id=5dc0744a"
import script from "./IdamSegmentator.vue?vue&type=script&lang=js"
export * from "./IdamSegmentator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports